/* eslint-disable global-require */
import { startApp } from "@quintype/framework/client/start";
import { renderApplication, preRenderApplication } from "./render";
import '../../app/assets/stylesheets/application.scss';

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => renderApplication(store));
  }
}

function offcanvasMenuReducer(state = false, action) {
  switch (action.type) {
    case "OPEN_OFFCANVAS_MENU": return true;
    case "CLOSE_OFFCANVAS_MENU": return false;
    case "QT_NAVIGATE": return false;
    default: return state;
  }
}

const CUSTOM_REDUCERS = {
  offcanvasMenu: offcanvasMenuReducer
};

// REMOVE ME
global.superagent = require("superagent-promise")(
  require("superagent"),
  Promise
);

const opts = {
  appVersion: require("../isomorphic/app-version"),
  enableServiceWorker: process.env.NODE_ENV === 'production',
  preRenderApplication,
};

if(window.OneSignal) {
  Object.assign(opts, {
    serviceWorkerLocation: '/OneSignalSDKWorker.js'
  });
}

require('whatwg-fetch');
global.superagent = require('superagent-promise')(require('superagent'), Promise);
startApp(renderApplication, CUSTOM_REDUCERS, opts).then(enableHotReload);
